import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../config/supabase';
import './Login.css';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showAdminPopup, setShowAdminPopup] = useState(false);
    const navigate = useNavigate();
    const { signIn, user } = useAuth();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const data = await signIn(formData.email, formData.password);
            
            // Check if user is admin
            const { data: userData } = await supabase
                .from('users')
                .select('role')
                .eq('id', data.user.id)
                .single();

            if (userData?.role === 'admin') {
                // Sign out and show popup
                await supabase.auth.signOut();
                setShowAdminPopup(true);
                setLoading(false);
                return;
            }

            // Redirect regular users to home
            navigate('/', { replace: true });

        } catch (err) {
            setError(err.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const goToAdminLogin = () => {
        setShowAdminPopup(false);
        navigate('/admin/login');
    };

    return (
        <div className="login-page">
            {/* Admin Popup */}
            {showAdminPopup && (
                <div className="admin-popup-overlay" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        background: 'white',
                        padding: '30px',
                        borderRadius: '12px',
                        textAlign: 'center',
                        maxWidth: '400px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
                    }}>
                        <h3 style={{ marginBottom: '15px', color: '#2563eb' }}>
                            Admin Account Detected
                        </h3>
                        <p style={{ marginBottom: '20px', color: '#666' }}>
                            This login is for regular users only.<br/>
                            Please use the Admin Login page.
                        </p>
                        <button
                            onClick={goToAdminLogin}
                            style={{
                                background: '#2563eb',
                                color: 'white',
                                border: 'none',
                                padding: '12px 30px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}
                        >
                            Go to Admin Login
                        </button>
                        <button
                            onClick={() => setShowAdminPopup(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: '#666',
                                marginTop: '10px',
                                cursor: 'pointer',
                                display: 'block',
                                width: '100%'
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            <div className="login-container">
                <div className="login-card">

                    <div className="login-header-section">
                        <h2>Welcome Back</h2>
                        <p>Sign in to continue</p>
                    </div>

                    {error && (
                        <div style={{
                            background: '#fff3cd',
                            color: '#856404',
                            border: '1px solid #ffc107',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            marginBottom: '16px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form-global">

                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="name@company.com"
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Enter password"
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        <button type="submit" className="login-submit-btn" disabled={loading}>
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>

                    <div className="login-footer-section">
                        <p>
                            Don't have an account?
                            <button
                                type="button"
                                className="toggle-btn"
                                onClick={() => navigate('/register')}
                            >
                                Sign Up
                            </button>
                        </p>
                        <p style={{ marginTop: '10px', fontSize: '0.85rem', color: '#888' }}>
                            Admin? <button type="button" className="toggle-btn" onClick={() => navigate('/admin/login')}>Login here</button>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Login;